import React from "react";
import { apiPost, getHostApi } from '../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from "../common/loadingComponent";
import { Collapse } from 'reactstrap';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form } from 'formik';
import { isIE } from '../common/utils';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { marketingListActions, unicornCountry } from '../../store/marketingListStore';
import { popupActions } from '../../store/popupStore';
import { withLocalize, Translate } from "react-localize-redux";
import BbCheckbox from '../styling/bbFormikCheckbox';
import BbInput from '../styling/bbInput';
import classnames from 'classnames';
import CrossIcon from '../../img/icons/Cross';
import ExportIcon from '../../img/icons/Export2';
import GreenSemaphore from '../../img/icons/GreenSemafor';
import Message from '../common/message';
import Paging from "../common/pagingComponent";
import RedSemaphore from '../../img/icons/RedSemafor';
import RelationLink from '../reportSections/relations/relationLink';
import ResponsiveTable from "../layoutItems/responsiveTable";
import SortDownIcon from '../../img/icons/SortingDown';
import SortUpIcon from '../../img/icons/SortingUp';
import YellowSemaphore from '../../img/icons/YellowSemafor';

class OverviewContent extends React.Component {
    state = {
        initValues: {
            exportSubjects: 'all',
            from: 1,
            to: 1000,
            orderBy: 'name',
            order: 'asc',
            columns: {
                name: false,
                companyId: false,
                nace: false,
                naceRuz: false,
                district: false,
                city: false,
                semaphore: false,
                turnover: false,
                employees: false,
                contacts: false
            }
        },
        showColumns: false,
        data: null,
        error: null,
        isLoading: true,
        page: 1,
        pageSize: 30
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps && (prevProps.requestId !== this.props.requestId || prevProps.user.language !== this.props.user.language)) {
            this.setState({ data: null })
            this.getData();
        }
    }

    orderByOptions = [
        { value: "name", key: "name", label: <Translate id='SearchResult.OrderBy.FullName' /> },
        { value: "companyId", key: "companyId", label: <Translate id='SearchResult.OrderBy.CompanyId' /> },
        { value: "employees", key: "employees", label: <Translate id='MarketingList.Common.EmployeesCategory' /> },
        { value: "turnover", key: "turnover", label: <Translate id='MarketingList.Common.Turnover' /> }
    ];

    render() {
        const isMobile = this.isMobile();
        return isMobile ? this.renderRightPanel() : this.renderContent(false);
    }

    renderRightPanel = () => (
        <article className="panel">
            <div className="panel-heading">
                <div className='panel-heading-title'>
                    <div style={{ marginRight: 'auto', marginTop: 'auto', marginBottom: 'auto' }}><Translate id="MarketingList.Results.PreviewOfSubjects" /> <b>{this.props.translate("MarketingList.Common.Shortening")}{this.requestId}</b></div>
                    <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{ marginLeft: '.5em' }} />
                </div>
            </div>
            <div className='search-progress'></div>
            <div className="panel-block">
                {this.renderContent(true)}
            </div>
        </article>
    )

    renderContent(isMobile) {
        if (this.state.error)
            return <Message type="error" message={this.props.translate(this.state.error.message || "UnhappyUser.InternalServerError")} options={{ renderInnerHtml: true }} />

        if (this.state.isLoading && this.state.data === null)
            return <Circles />

        return <Formik initialValues={this.state.initValues}
            render={({ values, setFieldValue }) => {
                var selectedCount = Object.values(values.columns).filter(f => f === true).length;
                return <>
                    <Form>
                        {isMobile ? this.renderMobileForm(values, setFieldValue, selectedCount) : this.renderForm(values, setFieldValue, selectedCount)}
                    </Form>
                    {this.renderTable(values, isMobile)}
                </>
            }} />
    }

    renderForm = (values, setFieldValue, selectedCount) => (
        <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div><b><Translate id="MarketingList.Overview.Export" />:</b></div>
                <BbInput type='radio' label=''
                    placeholder={{ type: 'column' }}
                    options={[
                        { value: "all", customLabel: `${this.props.translate('MarketingList.Overview.All')} (${this.state.data.subjectsCount})` },
                        { value: "subjects", label: 'MarketingList.Overview.Subjects' }
                    ]}
                    idFormat={(val) => `$radio-export-subjects-${val}`}
                    checkedValue={values.exportSubjects}
                    callback={(val) => setFieldValue(`exportSubjects`, val)}
                    style={{ marginBottom: 0, whiteSpace: 'nowrap' }}
                />
                <BbInput
                    label=''
                    name={`from`}
                    type="number"
                    placeholder={{ type: 'column' }}
                    min={1} max={values.to}
                    style={{ marginBottom: 0, marginLeft: '2em' }}
                    disabled={values.exportSubjects === 'all'}
                />
                <div style={{ paddingLeft: '1.5em' }}><Translate id="MarketingList.Overview.To" /></div>
                <BbInput
                    label=''
                    name={`to`}
                    type="number"
                    placeholder={{ type: 'column' }}
                    min={values.from} max={this.state.data.subjectsCount}
                    style={{ marginBottom: 0 }}
                    disabled={values.exportSubjects === 'all'}
                />
                <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.export(values)} type="button"
                    style={{ marginLeft: '5em', padding: '0.75em', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    disabled={!this.isValidExport(values)}>
                    {!isIE() && <ExportIcon style={{ height: '2.1em', fill: 'white', marginLeft: '-1.5em' }} />}
                    <Translate id='Search.Filter.Export' />
                </button>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.setState({ showColumns: !this.state.showColumns })} type="button"
                    style={{ marginRight: '50px' }}
                >
                    <Translate id='MarketingList.Overview.Show' />
                </button>
                {this.renderOrderBy(values, setFieldValue)}
            </div>
            {this.renderColumns(values, selectedCount)}
        </>
    )

    renderMobileForm = (values, setFieldValue, selectedCount) => (
        <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div><b><Translate id="MarketingList.Overview.Export" /></b></div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <BbInput type='radio' label='MarketingList.Overview.Export'
                        placeholder={{ type: 'inline' }}
                        options={[
                            { value: "all", customLabel: `${this.props.translate('MarketingList.Overview.All')} (${this.state.data.subjectsCount})` },
                            { value: "subjects", label: 'MarketingList.Overview.Subjects' }
                        ]}
                        idFormat={(val) => `$radio-export-subjects-${val}`}
                        checkedValue={values.exportSubjects}
                        callback={(val) => setFieldValue(`exportSubjects`, val)}
                        style={{ marginBottom: 0, whiteSpace: 'nowrap' }}
                    />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <BbInput
                            label=''
                            name={`from`}
                            type="number"
                            placeholder={{ type: 'inline' }}
                            min={1} max={values.to}
                            style={{ marginBottom: 0, marginLeft: '0.5em' }}
                            disabled={values.exportSubjects === 'all'}
                        />
                        <div style={{ marginLeft: '0.5em' }}><Translate id="MarketingList.Overview.To" /></div>
                        <BbInput
                            label=''
                            name={`to`}
                            type="number"
                            placeholder={{ type: 'inline' }}
                            min={values.from} max={this.state.data.subjectsCount}
                            style={{ marginBottom: 0, marginLeft: '0.5em' }}
                            disabled={values.exportSubjects === 'all'}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', margin: '0.5em 0' }}>
                    <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => this.export(values)} type="button"
                        style={{ padding: '0.75em', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        disabled={!this.isValidExport(values)}>
                        {!isIE() && <ExportIcon style={{ height: '2.1em', fill: 'white', marginLeft: '-1.5em' }} />}
                        <Translate id='Search.Filter.Export' />
                    </button>
                </div>
                <div className='search-filter-box' key='overview-columns' style={{ fontSize: '1em', margin: '0 -0.55em' }}>
                    <div className='search-filter-title' onClick={() => this.setState({ showColumns: !this.state.showColumns })}>
                        <span>
                            {this.props.translate("MarketingList.Overview.Show")}
                        </span>
                        <FontAwesomeIcon className='svg-standard-color' icon={!this.state.collapse ? "angle-up" : "angle-down"} />
                    </div>
                    {this.state.showColumns && <div style={{ fontSize: '0.8em', paddingLeft: '0.65em' }}><Translate id='MarketingList.Overview.Max5columns' /></div>}
                    {this.renderMobileColumns(values, selectedCount)}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', margin: '0.5em 0' }}>
                    {this.renderOrderBy(values, setFieldValue)}
                </div>
            </div>

        </>
    )

    isValidExport = (values) => {
        return !(values.exportSubjects === 'subjects'
            && (values.from < 1
                || values.from > values.to
                || values.to > this.state.data.subjectsCount));
    }

    export = (values) => {
        if (this.isValidExport(values)) {
            var data = { requestId: this.requestId, export: this.exportId, order: values.order, orderBy: values.orderBy, updateFromTo: true };
            if (values.exportSubjects === 'subjects') {
                data.exportFrom = values.from;
                data.exportTo = values.to;
            }
            this.props.showPopup('requestsPopup', {
                open: true,
                close: () => { this.props.hidePopup() },
                data
            });
        }
    }

    resetSubjects = (setFieldValue) => {
        setFieldValue("from", 1);
        setFieldValue("to", this.state.data.marketingListLimit);
        setFieldValue("exportSubjects", "all");
    }

    renderOrderBy = (values, setFieldValue) => (
        <>
            <div><Translate id='SearchResult.OrderBy' />:</div>
            <BbInput type='select' label=''
                options={this.orderByOptions}
                onChange={(e) => { setFieldValue("orderBy", e.value); this.getData(this.state.page, null, values.order, e.value); this.resetSubjects(setFieldValue); }}
                value={this.orderByOptions.find(f => f.value === values.orderBy)}
                style={{ width: '295px', marginBottom: 0 }}
            />
            {values.order === 'asc' ?
                <SortDownIcon className='search-results-manager-fill with-pointer svg-standard-fill' onClick={() => { setFieldValue("order", 'desc'); this.getData(this.state.page, null, 'desc', values.orderBy); this.resetSubjects(setFieldValue); }} style={{ width: '1.5em' }} /> :
                <SortUpIcon className='search-results-manager-fill with-pointer svg-standard-fill' onClick={() => { setFieldValue("order", 'asc'); this.getData(this.state.page, null, 'asc', values.orderBy); this.resetSubjects(setFieldValue); }} style={{ width: '1.5em' }} />
            }
        </>
    )

    columns =
        {
            "name": { name: "name", translationKey: "MarketingList.Common.FullName", id: "name", country: null },
            "companyId": { name: "companyId", translationKey: "MarketingList.Common.CompanyId", id: "companyId", country: null },
            "nace": { name: "nace", translationKey: "MarketingList.TimeSeries.MainNace", id: "nace", country: null },
            "naceRuz": { name: "naceRuz", translationKey: "MarketingList.TimeSeries.MainNaceRuz", id: "naceRuz", country: 'sk' },
            "district": { name: "district", translationKey: "Common.District", id: "district", country: null },
            "city": { name: "city", translationKey: "MarketingList.Common.City", id: "city", country: null },
            "semaphore": { name: "semaphore", translationKey: "MarketingList.Overview.Semaphore", id: "semaphore", country: null },
            "turnover": { name: "turnover", translationKey: "MarketingList.Common.Turnover", id: "turnover", country: null },
            "employees": { name: "employees", translationKey: "MarketingList.Common.EmployeesCategory", id: "employees", country: null },
            "contacts": { name: "contacts", translationKey: "MarketingList.Overview.Contacts", id: "contacts", country: null },
        };

    renderCheckbox = (column, values, selectedCount) => {
        if (isNullOrUndefined(column) || !isNullOrUndefined(column.country) && unicornCountry() !== column.country)
            return null;

        return <BbCheckbox key={column.name} name={`columns.${column.name}`} label={this.props.translate(column.translationKey)} id={column.id} disabled={selectedCount > 4 && !values.columns[column.name]} />
    }

    renderColumns = (values, selectedCount) => (
        this.state.showColumns && <div className='column-options card' style={{ position: 'absolute', borderRadius: '5px', width: '900px' }}>
            <div style={{ padding: '0.5em' }}>
                <div>
                    <Translate id='MarketingList.Overview.Max5columns' />
                    <CrossIcon className='icon-centered' onClick={() => this.setState({ showColumns: false })} style={{ width: '1em', height: '1em', float: 'right', cursor: 'pointer' }} />
                </div>
                <div className='columns'>
                    <div className='column'>
                        {this.renderCheckbox(this.columns.name, values, selectedCount)}
                        {this.renderCheckbox(this.columns.companyId, values, selectedCount)}
                        {this.renderCheckbox(this.columns.nace, values, selectedCount)}
                        {this.renderCheckbox(this.columns.naceRuz, values, selectedCount)}
                    </div>
                    <div className='column'>
                        {this.renderCheckbox(this.columns.district, values, selectedCount)}
                        {this.renderCheckbox(this.columns.city, values, selectedCount)}
                        {this.renderCheckbox(this.columns.semaphore, values, selectedCount)}
                    </div>
                    <div className='column'>
                        {this.renderCheckbox(this.columns.turnover, values, selectedCount)}
                        {this.renderCheckbox(this.columns.employees, values, selectedCount)}
                        {this.renderCheckbox(this.columns.contacts, values, selectedCount)}
                    </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => { if (selectedCount <= 5) { this.setState({ showColumns: false }); this.getData(this.state.page, values.columns, values.order, values.orderBy); } }} type="button">
                        <Translate id='Common.Button.Save' />
                    </button>
                </div>
            </div>
        </div>
    )

    renderMobileColumns = (values, selectedCount) => (
        <Collapse isOpen={this.state.showColumns}>
            <div className='column-options' style={{ padding: '0.5em' }}>
                {Object.keys(this.columns).map(key => this.renderCheckbox(this.columns[key], values, selectedCount))}
                <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                    <button className={classnames('bb-button small is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={() => { if (selectedCount <= 5) { this.setState({ showColumns: false }); this.getData(this.state.page, values.columns, values.order, values.orderBy); } }} type="button">
                        <Translate id='Common.Button.Save' />
                    </button>
                </div>
            </div>
        </Collapse>
    )

    renderTable = (values, isMobile) => (
        this.state.isLoading ? <Circles /> :
            <>
                <ResponsiveTable>
                    <table className="table table-report-section table-marketing-list fixed">
                        <thead>
                            <tr>
                                <th style={{ width: '3%' }}><Translate id="MarketingList.Overview.No" /></th>
                                {this.state.data.columnConfig.name && <th> <Translate id="MarketingList.Common.FullName" /></th>}
                                {this.state.data.columnConfig.companyId && <th><Translate id="MarketingList.Common.CompanyId" /></th>}
                                {this.state.data.columnConfig.nace && <th><Translate id="MarketingList.TimeSeries.MainNace" /></th>}
                                {this.state.data.columnConfig.naceRuz && <th><Translate id="MarketingList.TimeSeries.MainNaceRuz" /></th>}
                                {this.state.data.columnConfig.district && <th><Translate id="Common.District" /></th>}
                                {this.state.data.columnConfig.city && <th><Translate id="MarketingList.Common.City" /></th>}
                                {this.state.data.columnConfig.semaphore && <th><Translate id="MarketingList.Overview.Semaphore" /></th>}
                                {this.state.data.columnConfig.turnover && <th><Translate id="MarketingList.Common.Turnover" /></th>}
                                {this.state.data.columnConfig.employees && <th><Translate id="MarketingList.Common.EmployeesCategory" /></th>}
                                {this.state.data.columnConfig.contacts && <th><Translate id="MarketingList.Overview.Contacts" /></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {!isNullOrUndefined(this.state.data) && this.state.data.subjects.map(
                                (r, i) => {
                                    const no = i + 1 + (this.state.page - 1) * this.state.pageSize;
                                    return <tr key={`${i}`} className="ml-request">
                                        {!isMobile && <td data-label={this.props.translate("MarketingList.Overview.No")} className="no-wrap">{no}</td>}
                                        {isMobile && <td>{`${this.props.translate("MarketingList.Overview.No")} ${no}`}</td>}
                                        {this.state.data.columnConfig.name && <td data-label={this.props.translate("MarketingList.Common.FullName")} className={classnames({ "text-shorten": !isMobile })}><RelationLink wrap entityName={r.name} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>}
                                        {this.state.data.columnConfig.companyId && <td data-label={this.props.translate("MarketingList.Common.CompanyId")} className={classnames({ "text-shorten": !isMobile })}><p title={r.companyId}>{r.companyId}</p></td>}
                                        {this.state.data.columnConfig.nace && <td data-label={this.props.translate("MarketingList.TimeSeries.MainNace")} className={classnames({ "text-shorten": !isMobile })}><p title={r.nace}>{r.nace}</p></td>}
                                        {this.state.data.columnConfig.naceRuz && <td data-label={this.props.translate("MarketingList.TimeSeries.MainNaceRuz")} className={classnames({ "text-shorten": !isMobile })}><p title={r.naceRuz}>{r.naceRuz}</p></td>}
                                        {this.state.data.columnConfig.district && <td data-label={this.props.translate("Common.District")} className={classnames({ "text-shorten": !isMobile })}><p title={r.district}>{r.district}</p></td>}
                                        {this.state.data.columnConfig.city && <td data-label={this.props.translate("MarketingList.Common.City")} className={classnames({ "text-shorten": !isMobile })}><p title={r.city}>{r.city}</p></td>}
                                        {this.state.data.columnConfig.semaphore && <td data-label={this.props.translate("MarketingList.Overview.Semaphore")} className="ov-semaphore-td">{this.renderSemaphore(r.semaphore)}</td>}
                                        {this.state.data.columnConfig.turnover && <td data-label={this.props.translate("MarketingList.Common.Turnover")} className={classnames({ "text-shorten": !isMobile })}><p title={r.turnover}>{r.turnover}</p></td>}
                                        {this.state.data.columnConfig.employees && <td data-label={this.props.translate("MarketingList.Common.EmployeesCategory")} className={classnames({ "text-shorten": !isMobile })}><p title={r.employees}>{r.employees}</p></td>}
                                        {this.state.data.columnConfig.contacts && <td data-label={this.props.translate("MarketingList.Overview.Contacts")} className={classnames({ "text-shorten": !isMobile })}><p title={r.contacts}>{r.contacts}</p></td>}
                                    </tr>
                                }
                            )
                            }
                        </tbody>
                    </table>
                </ResponsiveTable>
                {this.renderPaging(values.order, values.orderBy)}
            </>
    )

    renderPaging = (order, orderBy) =>
        (!isNullOrUndefined(this.state.data) && this.state.data.maxRows > this.state.pageSize) ? (
            <div className='paging-wrapper'>
                <Paging selectedPage={this.state.page}
                    totalPages={Math.ceil(this.state.data.maxRows / this.state.pageSize)}
                    setPage={page => { this.getData(page, null, order, orderBy); }} />
            </div>
        ) : null;

    getData = (page, columnConfig, order, orderBy) => {
        if (!page)
            page = 1;
        this.setState({ isLoading: true, page });
        var model = {
            requestId: this.requestId,
            offset: (page - 1) * this.state.pageSize,
            count: this.state.pageSize,
            columnConfig,
            order,
            orderBy
        };
        apiPost(getHostApi() + `/api/marketing-list/request-items-overview`, undefined, model,
            (res) => {
                var initValues = null;
                if (res.data)
                    initValues = { ...this.state.initValues, from: res.data.from || 1, to: res.data.to || res.data.marketingListLimit, columns: res.data.columnConfig, order: res.data.order, orderBy: res.data.orderBy, exportSubjects: res.data.from ? 'subjects' : 'all' };
                this.setState({ data: res.data, error: res.error, isLoading: false, initValues });
            },
            (e) => this.setState({ data: null, error: e.data.error, isLoading: false })
        );
    }

    renderSemaphore = (code) => {
        if (code === undefined || code === null)
            return null;

        if (code === "1")
            return <div><GreenSemaphore /></div>
        else if (code === "2")
            return <div><YellowSemaphore /></div>
        else if (code === "3")
            return <div><RedSemaphore /></div>

        return null;
    }

    get requestId() {
        return !isNullOrUndefined(this.props.requestId) ? this.props.requestId : !isNullOrUndefined(this.props.overviewRequestId) ? this.props.overviewRequestId : null;
    }

    get exportId() {
        return !isNullOrUndefined(this.props.exportId) ? this.props.exportId : !isNullOrUndefined(this.props.overviewExportId) ? this.props.overviewExportId : null;
    }

    isMobile = () => window.innerWidth <= 992;
}

export default withLocalize(connect(
    state => ({ ...state.marketingList, user: state.userContext, popup: state.popup }),
    dispatch => bindActionCreators({ ...popupActions, ...marketingListActions }, dispatch)
)(OverviewContent));
